/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Source_LabelInputs */



/**
* | output |
* | --- |
* | "Source Event Group" |
*
* @param {Segment_Event_Group_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_source_label = /** @type {((inputs?: Segment_Event_Group_Source_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Source_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'evenements source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellereignisgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi di origine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа событий источника")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースイベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत घटना समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos de Origem")
	return /** @type {LocalizedString} */ ("Source Event Group")
});